export const CLASES_CONTENT = {
    lessons: {
        // clases.grilla-consulta — «La grilla de la sede (consulta)» — roles: receptionist (Recepcionista) — pantalla: "clases.grilla-consulta" — práctica: no
        "clases.grilla-consulta": {
            summary: "Aprendés a consultar la grilla del mes de tu sede para contestar en segundos en el mostrador: qué clases hay, a qué hora, con qué profe y con qué cupo, y cómo pasar de una clase a su ficha para reservar por un socio o anotar una clase de prueba. Es una vista de sólo lectura: la grilla la arman otros.",
            keyPoints: [
                "Entrás por Clases → Clases de la sede. Muestra sólo la grilla de tu sede activa, que acá no se cambia: si atendés en otra sede, cambiás la sede activa arriba. El mes sí lo elegís.",
                "Arriba ves si la grilla está publicada y cuántas clases activas tiene. Publicada quiere decir que los socios ya la ven en la app: lo que ves vos es lo mismo que ven ellos.",
                "Vista semana: las clases por local y salón, día por día, con hora, disciplina, profe y cupo, y la barrita de ocupación del mes anterior («no se pudo medir» no es cero). Vista mes: el calendario completo con los feriados marcados.",
                "Tocás una clase y ves su resumen (profe, salón, duración, cupo y visitantes de convenio que admite). Con «Abrir ficha de clase» llegás a la ficha, donde elegís la fecha y reservás por un socio o anotás una prueba.",
                "No creás, movés ni publicás clases, ni mirás otras sedes: la grilla la arman el encargado, la coordinación o Administración. Sí podés exportarla en PDF para imprimirla.",
                "Si ves un error, o tu sede no tiene grilla para ese mes, avisale al encargado: todavía no la armó.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
        // clases.grilla — «Armar y publicar la grilla del mes» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "clases.grilla" — práctica: sí
        "clases.grilla": {
            summary: "Cómo se arma la grilla mensual de una sede: clonar el mes anterior, mirar la ocupación para decidir bajas, ajustar las clases, cargar y decidir los feriados, publicar y exportar. Aprendés qué valida solo el sistema al cargar una clase y por qué publicar es una decisión que avisa a los socios, no un simple guardado.",
            keyPoints: [
                "Lo normal es clonar el mes anterior (se copian las clases activas y la grilla nace en borrador) y ajustar. La barrita de cada clase es la ocupación del mes anterior: te dice qué conviene dar de baja; «no se pudo medir» no es cero.",
                "Al cargar una clase, el cupo viene del salón: se puede bajar, nunca superar. Podés poner un máximo de visitantes para que los convenios no desplacen socios. El sistema frena los choques de salón y de profe, aunque sean en locales distintos.",
                "En Feriados del mes cargás el feriado que falte (vale para las tres sedes) y marcás qué clases se dictan: lo que no marcás, no se dicta, y no se recupera ni se devuelve.",
                "Publicar no es guardar: avisa a los socios de la sede, genera las fechas de cada clase y las reservas de los fijos. En borrador no se entera nadie; una grilla vacía no se publica y una publicada no se despublica.",
                "Cambiar una clase publicada pide un motivo, que ven los fijos y los inscriptos en el aviso. Si cargaste un feriado con la grilla ya publicada, las fechas de ese día siguen en pie: las que no se dicten se cancelan desde la ficha de cada clase.",
                "La arman y publican el encargado de sede, coordinación, Administración o el dueño; recepción la ve en sólo lectura desde Clases de la sede. Con Exportar PDF la bajás para difundirla en redes, por fuera del sistema.",
            ],
            estimatedMin: 8,
            contentVersion: 2,
        },
        // clases.ficha — «La ficha de clase: lista, reservas y suspensiones» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "clases.ficha" — práctica: sí
        "clases.ficha": {
            summary: "La ficha de clase reúne todo lo de una clase de la grilla: sus fijos y solicitudes de fijación y, por cada fecha, los inscriptos, la lista de espera y la asistencia, que después se usa para pagarle al profe. Aprendés a reservar en nombre de un socio, anotar una clase de prueba, y cuándo y quién suspende una fecha o corrige la asistencia.",
            keyPoints: [
                "Recepción reserva por un socio que no maneja la app y anota clases de prueba. Otorgar o quitar fijos, cancelar una fecha y corregir la asistencia es de encargado para arriba.",
                "Fijar es tener el lugar todas las semanas sin anotarse: sólo planes trimestrales, semestrales, anuales y el pase Solo Reformer; los visitantes no fijan. Si no hay lugar queda como solicitud, y el encargado prioriza planes largos y a quien viene seguido. Dos faltas en quince días hacen caer la fijación sola.",
                "La reserva por un socio queda igual que si la hubiera hecho él, con tu usuario. Si se pasa de su límite semanal, el extra se cobra en el mostrador y entra al turno de caja abierto.",
                "La clase de prueba es una por persona de por vida, controlada por documento, y ocupa cupo. Anotarla no la cobra: el cargo queda pendiente y se cobra desde Mostrador → Cobrar.",
                "La lista se consolida al minuto quince: hasta ahí el profe marca presentes. Después, corregir la asistencia es de encargado o superior y con motivo, porque cambia premios, penalidades y reportes.",
                "Suspender una fecha (profe enfermo, corte de luz) lo hace un encargado con motivo: libera las reservas y avisa a inscriptos y profe. Ninguna clase se cancela sola por poca gente, la lista de espera es por orden estricto y un profe no puede cancelar su clase.",
            ],
            estimatedMin: 9,
            contentVersion: 2,
        },
        // clases.ocupacion — «Ocupación y asistencia» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "clases.ocupacion" — práctica: no
        "clases.ocupacion": {
            summary: "Cómo leer el reporte de ocupación y asistencia para decidir la grilla del mes siguiente con la gente que vino de verdad, no con la que se anotó. Aprendés qué mide cada indicador, por qué una fecha sin consolidar no es un cero y cómo usar el ranking de clases con poca gente.",
            keyPoints: [
                "Filtrás por sede, local, mes, disciplina o profesor, y con Agrupar mirás por clase, disciplina, profesor, franja horaria o sede.",
                "Cuatro números: clases dictadas (y cuántas se consolidaron), ocupación (presentes sobre cupo), asistencia sobre reservas (de los anotados, cuántos vinieron) y faltas (cancelaciones tardías e inasistencias).",
                "Una fecha sin consolidar no aporta presentes: un porcentaje vacío no es 0 %, es un dato que todavía no existe. La columna Medidas dice sobre cuántas fechas se midió de verdad.",
                "El ranking de clases con poca gente muestra las candidatas a la baja del mes que viene, y sólo entran las que se pudieron medir. Sin asistencia consolidada no hay ranking, y el reporte lo dice.",
                "Asistentes por profesor separa socios y visitantes: los visitantes cuentan para los premios, y esa separación respalda el control de lo que liquidan SportClub y Wellhub.",
                "Se exporta a CSV como insumo de la grilla siguiente. El reporte no se corrige: la asistencia se corrige en la ficha de clase, con motivo. «Sin clases en el período» suele ser una grilla sin publicar.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // clases.eventos — «Eventos (master y Viva Games)» — roles: branch_manager (Encargado de sede), intersede_coordinator (Coordinador intersedes), admin (Administración), owner (Dueño) — pantalla: "clases.eventos" — práctica: no
        "clases.eventos": {
            summary: "Cómo crear, publicar y gestionar los eventos: clases master y Viva Games. Aprendés en qué se diferencian de una clase de la grilla, cuándo queda confirmada una inscripción y qué pasa si el club cancela.",
            keyPoints: [
                "Un evento tiene tipo, nombre, fecha y hora, local, cupo y precio de inscripción: las master se cobran y los Viva Games pueden ser sin cargo. Si es por equipos, se marca al crearlo.",
                "Nace en borrador y nadie lo ve. Al publicarlo, los socios se inscriben por la app y vos desde el mostrador.",
                "En el mostrador, si cobrás la inscripción en el acto, queda confirmada y el cobro entra al turno de caja abierto. Si no, ocupa lugar pero queda pendiente de pago y no confirmada, y se completa después con «Cobrar en mostrador».",
                "Los eventos no consumen el límite semanal del socio, no admiten fijos y no generan recuperos. No se inscribe en un evento en borrador, cerrado o cancelado.",
                "Cancelar un evento exige motivo: se dan de baja las inscripciones, se devuelve lo cobrado como reverso del pago original, registrado, y se avisa a los inscriptos.",
                "Crean y gestionan eventos los encargados, coordinación, Administración y los dueños.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
    },
    questions: [
        // ── clases.grilla-consulta ──────────────────────────────────────────────
        {
            id: "clases.grilla-consulta#1",
            lessonKey: "clases.grilla-consulta",
            prompt: "Hoy te toca atender en otra sede y en Clases de la sede seguís viendo la grilla de la tuya. ¿Qué hacés?",
            options: [
                { id: "a", text: "Elegís la otra sede en el selector de la grilla." },
                { id: "b", text: "Cambiás la sede activa arriba, y la grilla pasa a ser la de esa sede." },
                { id: "c", text: "Le pedís al encargado que te mande el PDF de la otra sede." },
                { id: "d", text: "No se puede: recepción sólo ve la grilla de la sede donde la dieron de alta." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, la grilla es la de tu sede activa y acá no se cambia. Si atendés en otra sede, cambiás la sede activa arriba, como en el módulo de inicio.",
        },
        {
            id: "clases.grilla-consulta#2",
            lessonKey: "clases.grilla-consulta",
            prompt: "Un socio pregunta si suele haber lugar en el funcional del martes y la barrita de esa clase dice «no se pudo medir». ¿Cómo lo leés?",
            options: [
                { id: "a", text: "Que el mes pasado no fue nadie a esa clase." },
                { id: "b", text: "Que la clase estuvo llena todo el mes y no admite más reservas." },
                { id: "c", text: "Que la clase se dio de baja." },
                { id: "d", text: "Que ese mes no hubo datos para medirla: no es un cero." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la barrita es la ocupación del mes anterior. Si dice «no se pudo medir», no es un cero: ese mes no hubo datos.",
        },
        {
            id: "clases.grilla-consulta#3",
            lessonKey: "clases.grilla-consulta",
            prompt: "Una socia te pide que la anotes en spinning del jueves. Estás mirando la grilla. ¿Cuál es el camino?",
            options: [
                {
                    id: "a",
                    text: "Tocás la clase, «Abrir ficha de clase», elegís la fecha y reservás.",
                },
                { id: "b", text: "Tocás la clase y la reservás desde el resumen que se abre." },
                { id: "c", text: "Le sumás un lugar al cupo de la clase y escribís su nombre." },
                { id: "d", text: "Le decís que se anote ella por la app: desde la grilla no se puede." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la grilla sirve para encontrar la clase: tocás la clase, se abre un resumen y con «Abrir ficha de clase» llegás a la ficha, donde elegís la fecha y reservás por el socio.",
        },
        {
            id: "clases.grilla-consulta#4",
            lessonKey: "clases.grilla-consulta",
            prompt: "Vas a mirar el mes que viene y te aparece que tu sede no tiene grilla. ¿Qué hacés?",
            options: [
                { id: "a", text: "La armás vos copiando la del mes actual." },
                { id: "b", text: "Le decís a los socios que ese mes no hay clases." },
                { id: "c", text: "Le avisás al encargado: todavía no la armó." },
                { id: "d", text: "Exportás el PDF del mes actual y lo publicás como el del mes que viene." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, desde acá no se crean ni publican clases. Si ves un error o la sede no tiene grilla para ese mes, le avisás al encargado: todavía no la armó.",
        },
        // ── clases.grilla ───────────────────────────────────────────────────────
        {
            id: "clases.grilla#1",
            lessonKey: "clases.grilla",
            prompt: "Querés pasar a la profe de funcional a las 19 h en el Local 2, pero a esa hora ya tiene yoga en el Local 1. ¿Qué pasa al guardar?",
            options: [
                { id: "a", text: "La guarda, porque son locales distintos." },
                { id: "b", text: "La guarda y le avisa a la profe que revise su horario." },
                { id: "c", text: "La guarda en borrador y el choque se resuelve al publicar." },
                { id: "d", text: "Te avisa del choque y no la guarda." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, al guardar el sistema controla solo: un profe no puede estar en dos clases superpuestas aunque sean en locales distintos, y si choca, te lo dice y no la guarda.",
        },
        {
            id: "clases.grilla#2",
            lessonKey: "clases.grilla",
            prompt: "En noviembre hay un feriado y en la grilla marcaste que sólo se dicta funcional de la mañana. ¿Qué pasa con las demás clases de ese día?",
            options: [
                { id: "a", text: "No se dictan, y no se recuperan ni se devuelven." },
                { id: "b", text: "Se pasan solas al día siguiente." },
                { id: "c", text: "Se dictan igual si tienen al menos un anotado." },
                { id: "d", text: "No se dictan, y a los socios se les acredita un recupero." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, en los feriados marcás qué clases sí se dictan: lo que no marcás no se dicta, y no se recupera ni se devuelve.",
        },
        {
            id: "clases.grilla#3",
            lessonKey: "clases.grilla",
            prompt: "Terminaste la grilla y estás por tocar Publicar. ¿Qué tenés que tener en cuenta?",
            options: [
                { id: "a", text: "Que es un guardado más: después la podés despublicar si falta algo." },
                {
                    id: "b",
                    text: "Que avisa a los socios, genera las fechas y no se despublica.",
                },
                { id: "c", text: "Que sólo la ven los profes hasta que recepción la difunda." },
                { id: "d", text: "Que se publica en las redes del club automáticamente." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, publicar no es guardar: llega un aviso a los socios, se generan las fechas y las reservas de los fijos, y una grilla publicada no se puede despublicar. Las redes se manejan por fuera, con el PDF.",
        },
        {
            id: "clases.grilla#4",
            lessonKey: "clases.grilla",
            prompt: "La grilla de diciembre ya estaba publicada y recién ahí cargaste un feriado que faltaba. ¿Qué pasa con las clases de ese día?",
            options: [
                { id: "a", text: "Se cancelan solas al cargar el feriado." },
                { id: "b", text: "Hay que despublicar la grilla, cargar el feriado y volver a publicarla." },
                {
                    id: "c",
                    text: "Siguen en pie: las cancelás desde la ficha de cada clase.",
                },
                { id: "d", text: "Se mueven al sábado siguiente." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, si cargás un feriado con la grilla ya publicada, las fechas de ese día ya existían y siguen en pie: las que no se dicten se cancelan desde la ficha de cada clase.",
        },
        // ── clases.ficha ────────────────────────────────────────────────────────
        {
            id: "clases.ficha#1",
            lessonKey: "clases.ficha",
            prompt: "Anotaste en recepción una clase de prueba para una interesada. ¿Qué pasa con el pago?",
            options: [
                { id: "a", text: "Se cobra automáticamente al anotarla, con el medio que tenga cargado." },
                { id: "b", text: "Es gratis: la clase de prueba no se cobra." },
                { id: "c", text: "Lo cobra el profe en el salón." },
                {
                    id: "d",
                    text: "Queda un cargo pendiente que cobrás desde Mostrador → Cobrar.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, anotar la clase de prueba no la cobra: el cargo queda pendiente y lo cobrás desde Mostrador → Cobrar. Si hay una promoción vigente, se aplica ahí.",
        },
        {
            id: "clases.ficha#2",
            lessonKey: "clases.ficha",
            prompt: "Una socia con pase mensual quiere fijar el lugar en pilates de los lunes. ¿Qué le decís?",
            options: [
                {
                    id: "a",
                    text: "Que con pase mensual no se puede fijar.",
                },
                { id: "b", text: "Que se lo fijás en el acto si hay lugar." },
                { id: "c", text: "Que queda como solicitud y el encargado decide." },
                { id: "d", text: "Que lo fija ella desde la app." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, fijar es sólo para planes trimestrales, semestrales, anuales y el pase Solo Reformer; los visitantes tampoco fijan.",
        },
        {
            id: "clases.ficha#3",
            lessonKey: "clases.ficha",
            prompt: "Un socio no pudo escanear el QR del salón al entrar a la clase. ¿Cómo queda presente?",
            options: [
                { id: "a", text: "No queda: sin QR es ausente." },
                { id: "b", text: "El profe lo marca presente antes del minuto quince." },
                { id: "c", text: "Recepción lo marca presente al día siguiente." },
                { id: "d", text: "Lo marca presente él mismo desde la app cuando quiera." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, la lista se consolida al minuto quince y hasta ahí el profe marca presentes. Después, corregir es de encargado o superior y con motivo.",
        },
        {
            id: "clases.ficha#4",
            lessonKey: "clases.ficha",
            prompt: "Se cortó la luz y la clase de las 20 h no se puede dar. Sos encargado. ¿Qué hacés?",
            options: [
                { id: "a", text: "Esperás: la clase se cancela sola si no llega gente." },
                { id: "b", text: "Le pedís al profe que la cancele desde su usuario." },
                {
                    id: "c",
                    text: "Tocás Cancelar esta fecha, con motivo.",
                },
                { id: "d", text: "Das de baja la clase de la grilla." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, suspender una fecha lo hace un encargado con Cancelar esta fecha y un motivo. Ninguna clase se cancela sola y un profe no puede cancelar su clase: avisa y el encargado decide.",
        },
        // ── clases.ocupacion ────────────────────────────────────────────────────
        {
            id: "clases.ocupacion#1",
            lessonKey: "clases.ocupacion",
            prompt: "En el reporte, la ocupación de una clase aparece vacía. ¿Qué significa?",
            options: [
                { id: "a", text: "Que no vino nadie: 0 %." },
                { id: "b", text: "Que la clase se dio de baja." },
                {
                    id: "c",
                    text: "Que sus fechas no se consolidaron: no es un cero.",
                },
                { id: "d", text: "Que el profe no cargó la lista y hay que contarla como 0 % hasta que la cargue." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, una fecha sin consolidar no aporta presentes, así que un porcentaje vacío no es un cero: es un dato que todavía no existe. La columna Medidas dice sobre cuántas fechas se midió.",
        },
        {
            id: "clases.ocupacion#2",
            lessonKey: "clases.ocupacion",
            prompt: "Una clase tuvo 20 reservas por fecha pero vinieron 8. ¿Qué indicador te lo muestra?",
            options: [
                { id: "a", text: "Asistencia sobre reservas." },
                { id: "b", text: "Ocupación: presentes sobre cupo." },
                { id: "c", text: "Clases dictadas." },
                { id: "d", text: "El ranking de clases con poca gente." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, la ocupación es presentes sobre cupo, mientras que asistencia sobre reservas mide, de los que se anotaron, cuántos vinieron.",
        },
        {
            id: "clases.ocupacion#3",
            lessonKey: "clases.ocupacion",
            prompt: "Estás decidiendo qué clases dar de baja el mes que viene. ¿Para qué te sirve el ranking de clases con poca gente?",
            options: [
                { id: "a", text: "Da de baja solas las clases del fondo del ranking." },
                {
                    id: "b",
                    text: "Te muestra las candidatas a la baja, entre las que se pudieron medir.",
                },
                { id: "c", text: "Ordena por reservas e incluye las clases sin consolidar contándolas como cero." },
                { id: "d", text: "Sirve para corregir la asistencia de las clases con poca gente." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el ranking muestra las candidatas a la baja del mes que viene, sólo con clases que se pudieron medir; con Ficha saltás a la clase. La decisión la tomás vos.",
        },
        {
            id: "clases.ocupacion#4",
            lessonKey: "clases.ocupacion",
            prompt: "En Asistentes por profesor, ¿por qué los visitantes de convenio aparecen separados de los socios?",
            options: [
                { id: "a", text: "Porque los visitantes no cuentan para nada en los premios ni en la ocupación de la clase." },
                { id: "b", text: "Porque los visitantes no ocupan cupo." },
                { id: "c", text: "Porque así se les cobra la clase en recepción." },
                {
                    id: "d",
                    text: "Porque cuentan para los premios y respaldan el control de los convenios.",
                },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, los visitantes cuentan para los premios de los profes, y separarlos es el respaldo para controlar lo que liquidan SportClub y Wellhub.",
        },
        // ── clases.eventos ──────────────────────────────────────────────────────
        {
            id: "clases.eventos#1",
            lessonKey: "clases.eventos",
            prompt: "Anotaste a una socia en la Master de Zumba pero no le cobraste en ese momento. ¿En qué estado queda?",
            options: [
                { id: "a", text: "Confirmada, y paga el día del evento." },
                {
                    id: "b",
                    text: "Ocupa lugar pero queda pendiente de pago, sin confirmar.",
                },
                { id: "c", text: "No ocupa lugar hasta que pague, pero queda confirmada para el día del evento." },
                { id: "d", text: "Se cancela sola a las 24 horas." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, sin cobro la inscripción ocupa lugar pero queda pendiente de pago y no confirmada; junto a esa persona aparece Cobrar en mostrador para completarla después.",
        },
        {
            id: "clases.eventos#2",
            lessonKey: "clases.eventos",
            prompt: "Creaste el evento de los Viva Games y un socio te pide que lo anotes ya, pero todavía no lo publicaste. ¿Qué pasa?",
            options: [
                { id: "a", text: "Lo anotás igual: en borrador sólo recepción puede inscribir." },
                { id: "b", text: "Lo anotás y queda en espera hasta que se publique." },
                { id: "c", text: "No se puede: primero lo publicás." },
                { id: "d", text: "Se anota él desde la app aunque esté en borrador." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el evento nace en borrador y nadie lo ve, y no se puede inscribir en un evento en borrador. Al publicarlo, los socios se inscriben por la app y vos desde el mostrador.",
        },
        {
            id: "clases.eventos#3",
            lessonKey: "clases.eventos",
            prompt: "Un socio con límite de 3 clases por semana ya usó las 3 y quiere anotarse en una master class esa semana. ¿Qué pasa?",
            options: [
                { id: "a", text: "Puede: los eventos no consumen el límite semanal del socio." },
                { id: "b", text: "No puede hasta la semana siguiente." },
                { id: "c", text: "Puede, pero se le descuenta una clase de la semana siguiente." },
                { id: "d", text: "Puede sólo si la fija." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, los eventos no consumen el límite semanal del socio, no admiten fijos ni generan recuperos.",
        },
        {
            id: "clases.eventos#4",
            lessonKey: "clases.eventos",
            prompt: "El club tiene que suspender un evento con inscripciones ya cobradas. ¿Qué pasa al cancelarlo?",
            options: [
                { id: "a", text: "Las inscripciones se borran y la plata queda como saldo del club." },
                {
                    id: "b",
                    text: "Pide motivo, da de baja las inscripciones y devuelve lo cobrado.",
                },
                { id: "c", text: "Se pasa a una fecha nueva con los mismos inscriptos." },
                { id: "d", text: "Las inscripciones cobradas se convierten en recuperos de clase." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, cancelar pide motivo: se dan de baja todas las inscripciones, cada devolución queda registrada como reverso del pago original y se avisa a los inscriptos.",
        },
    ],
};
//# sourceMappingURL=clases.js.map